import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "commonPantryDialogOverlay" }
const _hoisted_2 = { class: "commonPantryDialogBox" }
const _hoisted_3 = { class: "pantry-camera-date-dialog-search-radio-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryCameraRadioItem = _resolveComponent("PantryCameraRadioItem")

  return (_openBlock(), _createBlock(_Transition, { name: "pantry-camera-date-dialog" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateList, (item) => {
              return (_openBlock(), _createBlock(_component_PantryCameraRadioItem, {
                class: "pantry-camera-date-dialog-radio",
                key: item.id,
                id: item.id,
                selectId: _ctx.nowId,
                valueText: item.date,
                onSelectCheck: _ctx.selectChecked
              }, null, 8, ["id", "selectId", "valueText", "onSelectCheck"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}